import { createFileRoute } from '@tanstack/react-router'
import { PopularManufacturersPage } from '@/features/popular-manufacturers'

export const Route = createFileRoute('/_authenticated/popular-manufacturers/')({
  component: PopularManufacturersPage,
})
